<template>
    <avue-crud
    :option="option"
    :table-loading="tableLoading"
    :data="tableData"
    :page="page"
    v-model="modelForm"
    ref="crud"
    @row-update="rowUpdate"
    @search-change="searchChange"
    @search-reset="searchReset"
    @current-change="currentChange"
    @size-change="sizeChange"
    @sort-change="sortChange"
    @on-load="onLoad"
    @row-del='rowDel'
    @refresh-change="refresh"
    >
    <!-- 操作按钮扩展 -->
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          @click="Initialize"
        >初始化</el-button>
        <el-tag type="success">温馨提示：在公用规则的字段授权中已配置内容，对所有资源的字段生效，无需单独增加！</el-tag>
      </template>
      <!--操作栏目-->
    <template slot-scope="{type,size,row}" slot="menu">
      <!-- 查看按钮 -->
      <el-tooltip v-if="row.type !== 'publicRule'" content="查看" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowView(row,row.$index)" :size="size" :type="type" icon="el-icon-view"></el-button>
      </el-tooltip>
      <!-- 编辑按钮 -->
       <el-tooltip v-if="row.type !== 'publicRule'" content="编辑" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowEdit(row,row.$index)" :size="size" :type="type" icon="el-icon-edit"></el-button>
      </el-tooltip>
      <!-- 删除按钮 -->
       <el-tooltip v-if="row.type !== 'publicRule'" content="删除" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowDel(row,row.$index)" :size="size" :type="type" icon="el-icon-delete"></el-button>
      </el-tooltip>
    </template>
    <!-- 单元格行内  -->
    <template v-slot:authority="{row}" >
      <el-tag type="info" v-if="row.authority === 'close'">不开放</el-tag>
      <el-tag type="warning" v-if="row.authority === 'read'">可读</el-tag>
    </template>
    </avue-crud>
</template>

<script>

export default {
  props: ['resourceId'],
  data() {
    return {
      tableLoading: false,
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      query: {},
      order: {
        oder: '',
        prop: ''
      },
      modelForm: {},
      option: {
        page: false,
        index: true,
        height: '200',
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 4,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'icon',
        column: [
          {
            label: '字段名',
            sortable: true,
            prop: 'fieldName',
            editDisabled: true
          },
          {
            label: '字段注释',
            prop: 'fieldComment'
          }, {
            label: '备注',
            prop: 'remark',
            span: 24,
            type: 'textarea'
          }, {
            label: '权限',
            prop: 'authority',
            type: 'select',
            slot: true,
            width: 100,
            sortable: true,
            dicData: [{
              label: '不开放',
              value: 'close'
            }, {
              label: '可读',
              value: 'read'
            }]
          }
        ]
      }
    }
  },
  components: {},
  methods: {
    onLoad(page = this.page, params = this.query, order = this.order) {
      let resourceId = this.resourceId
      if (!resourceId) {
        this.tableData = []
        this.page.total = 0
        return
      }
      let orderItemList = []
      if (order.order) {
        orderItemList.push({
          asc: order.oder === 'ascending',
          column: order.prop
        })
      }
      this.tableLoading = true
      this.$http.post('/t-data-collection-resource-field/query', { 'entity': Object.assign(params, { resourceId }), orderItemList }, { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.tableLoading = false
          this.tableData = response.data.records
          this.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.tableLoading = false
          this.$message.error(error.msg || error.message)
        }
      )
    },
    // 编辑行
    rowUpdate(row, index, loading, done) {
      this.$http.put('/t-data-collection-resource-field', row)
        .then(response => {
          this.$message.success('编辑成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg || error.message) && done()
        })
    },
    // 搜索改变事件
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') delete params[key]
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    // 排序改变
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    refresh: function() {
      this.onLoad()
    },
    Initialize() {
      this.$confirm('确定要进行初始化吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/t-data-collection-resource-field/init-resource', null, {
          params: {
            resourceId: this.resourceId
          }
        }).then(res => {
          this.$message.success('初始化成功')
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(e => {})
    },
    rowDel(row, index) {
      this.$confirm('确定要删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/t-data-collection-resource-field/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(e => {})
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
